<template>
  <el-dialog :visible.sync="cropperVisible" append-to-body title="图片裁剪">
    <div class="cropper-content">
      <div style="text-align: center; width: auto; height: 400px">
        <!--{{ option.fixedNumber }}-->
        <vueCropper
          ref="cropper"
          :autoCrop="option.autoCrop"
          :canMove="option.canMove"
          :canMoveBox="option.canMoveBox"
          :centerBox="option.centerBox"
          :fixed="option.fixed"
          :fixedBox="option.fixedBox"
          :fixedNumber="option.fixedNumber"
          :full="option.full"
          :img="option.img"
          :info="true"
          :infoTrue="option.infoTrue"
          :original="option.original"
          :outputSize="option.size"
          :outputType="option.outputType"
        ></vueCropper>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancel">取消</el-button>
      <el-button :loading="loading" type="primary" @click="onsubmit">
        保存
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "wan-cropper",

  props: {
    cropperParams: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      cropperVisible: false,
      loading: false,
      option: {
        file: null,
        img: "", // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 0.8, // 裁剪生成图片的质量
        outputType: "jpeg", // 裁剪生成图片的格式
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 200, // 默认生成截图框宽度
        autoCropHeight: 200, // 默认生成截图框高度
        fixedBox: true, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [200, 200], // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        canMoveBox: false, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        infoTrue: false, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      },
    };
  },

  watch: {
    cropperParams: {
      handler(n) {
        this.option.img = n.url;
        this.option.fixedNumber = n.fixedNumber;
        this.option = JSON.parse(JSON.stringify(this.option));
      },
      deep: true,
    },
  },

  methods: {
    // 取消
    cancel() {
      console.log(this.option);
      this.cropperVisible = false;
    },

    // 保存的
    onsubmit() {
      this.$refs.cropper.getCropBlob((data) => {
        let file = new window.File([data], this.cropperParams.name, {
          type: this.cropperParams.type,
        });
        let imageUrl = window.URL.createObjectURL(data);
        this.cropperVisible = false;
        this.$emit("onsubmit", { file, imageUrl });
      });
    },
  },
};
</script>

<style scoped></style>
